module.exports = __webpack_public_path__ + "static/media/logo189.256c998e.png";